import { ImportVesselForm } from "@smartship-services/ui/forms";

const ImportVesselPage = () => {
  return <ImportVesselForm />;
};

export default ImportVesselPage;
